import React from "react";
import { useEffect, useState, useRef } from "react";
import { getdisbursementpaymentlist,getdisbursementbatchfilelist,generateabafile } from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles,dynamicUrl} from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import { format } from 'date-fns';
import "../WithDrawals/withdrawal.css"
import { useNavigate } from "react-router-dom";


const WithDrawals = () => {
    const [withdrawLists, setWithdrawLists] = useState([]);
    const [allDetails , setAllDetails] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(4);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(30);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowIds, setRowIds] = useState("");
    const [totalPages, setTotalPages] = useState(0);
    const ToastRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getWithdrawalsList(1, 30);
    }, [userId, searchText, purpose]);

    console.log(purpose,'purpose')


    const getWithdrawalsList = (currentPage, totalRows) => {
        const baseUrl =  purpose === null ? getdisbursementbatchfilelist : getdisbursementpaymentlist ;
        let data = {
            AgencyId: agencyID,
            PaymentMethod: purpose,
            PageNo: currentPage,
            SortBy: "CreatedDate",
            SortOrder: "Desc",
            RecordsPerPage: totalRows,
        };
        if (purpose === null){
           delete data.PaymentMethod
        }

        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                debugger
                if (response.status === ActionStatus.Successfull) {
                    if(purpose === 5){
                    let disbursementData = response.object.bpayPaymentList;
                    let withdrawList = disbursementData
                        .map((dis) => ({
                            created: format(new Date(dis.createdAt), 'dd/MM/yyyy'),
                            Property: dis.propertyAddress,
                            supplier: dis.supplierName,
                            billerCode: dis.billerCode,
                            CustomerReference:dis.bpayReference,
                            Amounts: dis.amount,
                            Statement:dis.statementId,
                            Completed: dis.isCompleted ? "Yes" : "No",
                            id: dis.id,
                        }));
                    setWithdrawLists(withdrawList);
                    }
                    else if(purpose !== null){
                    let disbursementData = response.object.paymentList;
                    let withdrawList = disbursementData
                        .map((dis) => ({
                            created: format(new Date(dis.createdAt), 'dd/MM/yyyy'),
                            payee: dis.accountName,
                            BSB: dis.accountBSB,
                            "Account #": dis.accountNumber,
                            Amounts: dis.amount,
                            Completed: dis.isCompleted ? "Yes" : "No",
                            id: dis.id,
                        }));
                    setWithdrawLists(withdrawList);
                    }
                    else{
                        let withdrawalData = response.list;
                        let withdrawList = withdrawalData
                        .map((dis) => ({
                            created: format(new Date(dis.createdAt), 'dd/MM/yyyy'),
                            Type: dis.paymentType === 1 ? "Cash" : dis.paymentType === 2 ? "Cheque" : dis.paymentType === 3 ? "Card" : dis.paymentType === 4 ? "EFT" : dis.paymentType === 5 ? "BPAY" : "",
                            batch: dis.batchNo,
                            Amounts: dis.totalAmount,
                            totalWithdrawals: dis.totalCount,
                            statement:'-',
                            Amount: dis.totalAmount,
                            Paymentmethod : dis.paymentType
                        }));
                    setWithdrawLists(withdrawList);
                    }
                    setAllDetails(response.object)
                    setTotalPages(response.totalCount)
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getWithdrawalsList(pageNumber, totalRows);
    };

    const tabColumns = {
        Completed: {
            colorMap: {
                "Yes": "#00A5A2",
                "No": "#E5A000",
            },
            defaultColor: 'blue'
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchText(value);
    };

   
    const onSelectedRowKeysChange = (selectedKeys, selectedRows) => {
        setRowIds(selectedKeys); // Store it as JSON string for easier display/use
    };
    
        
    const handleStatClick = (selectedPurpose) => {
          setPurpose(selectedPurpose);
      };

    const submitAbafile = () => {
        const baseUrl = generateabafile;
        let data = {
            Ids: rowIds,
            AgencyId: agencyID,
            PaymentMethods: purpose
        };
        data = addParametersForProfiles(data);
        showSpinner();
        fetch(baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(async (res) => {
                if (!res.ok) {
                    throw new Error("Failed to generate ABA file");
                }
                // Get filename from header if available
                const disposition = res.headers.get("Content-Disposition");
                let fileName = "disbursement.aba";
                if (disposition) {
                    // Try to get UTF-8 filename*= first
                    const utf8Match = disposition.match(/filename\*\=UTF-8''([^;]+)/);
                    const fallbackMatch = disposition.match(/filename="?([^"]+)"?/);

                    if (utf8Match?.[1]) {
                        fileName = decodeURIComponent(utf8Match[1]);
                    } else if (fallbackMatch?.[1]) {
                        fileName = fallbackMatch[1];
                    }
                }
                const blob = await res.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                ToastRef.current.notify(["success", "ABA file downloaded successfully"]);
                getWithdrawalsList(1, 10);
            })
            .catch(() => {
                ToastRef.current.notify(["error", "Failed to download ABA file"]);
            })
            .finally(() => {
                hideSpinner();
            });
    };

    const handleViewMonth = (e,data) => {
         dynamicUrl(navigate, `accounts/disbursements/WithDrawalsBatch?Paymentmethod=${data.Paymentmethod}&&FileReference=${data.batch}`);
       }

    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Withdrawals"} goback={true} extraData={true} extraContent={
                        <div>
                            {purpose === 4 ?
                                <div className="mb-2" onClick={submitAbafile}>
                                    <span className="withdraw-btn">Create ABA bank file</span>
                                </div> : null}
                        </div>
                    } />
                    <div className="material-work-desk-new bg-white m-3">
                    <ToastAlert ref={ToastRef} />
                        <div className="">
                            <span className={`stat-items ${purpose === 4 ? 'active' : ''}`} onClick={() => handleStatClick(4)}>
                                EFT  {allDetails?.eftCount && (<span className="count">{allDetails?.eftCount}</span>)}
                            </span>
                            <span className={`stat-items ${purpose === 2 ? 'active' : ''}`} onClick={() => handleStatClick(2)}>
                                Cheques {allDetails?.chequeCount && (<span className="count">{allDetails?.chequeCount}</span>)}
                            </span>
                            <span className={`stat-items ${purpose === 5 ? 'active' : ''}`} onClick={() => handleStatClick(5)}>
                                BPay {allDetails?.bPayCount && (<span className="count">{allDetails?.bPayCount}</span>)}
                            </span>
                            <span className={`stat-items ${purpose === null ? 'active' : ''}`} onClick={() => handleStatClick(null)}>
                                Genarated Batches 
                            </span>

                        </div>
                        <AntdTableExample
                            showCount
                            showCheckbox
                            label="List Withdrawals"
                            dataSource={withdrawLists}
                            globalSearch
                            hideCol={"id,Paymentmethod"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            tagColumns={tabColumns}
                            onSearchValueChange={handleSearchValueChange}
                            onSelectedRowKeysChange={onSelectedRowKeysChange}
                            initialSelectedRowKeys={rowIds}
                            onMonthClick={(e,data) => handleViewMonth(e,data)}
                            totalRecords={totalPages}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WithDrawals;
